import axios from "axios";

const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://robsdyno.malejkoit.com/api/v1.0.0/"
    : "http://localhost:8000/api/v1.0.0/";

export const getBrandingInfo = async (
  hostname = typeof window !== "undefined" ? window.location.hostname : ""
) => {
  try {
    const response = await axios.get(`${API_URL}branding/`, {
      params: { hostname },
    });
    const data = response.data?.data || response.data || {};
    return {
      exists: data.exists !== false,
      logoUrl: data.logoUrl || data.logo_url || null,
      companyName: data.companyName || data.company_name || null,
      companyShortName:
        data.companyShortName || data.company_short_name || null,
    };
  } catch {
    return {
      exists: true,
      logoUrl: null,
      companyName: null,
      companyShortName: null,
    };
  }
};

export const getBrandingLogoUrl = async () => {
  const info = await getBrandingInfo();
  return info.logoUrl;
};
